import {ModuleWithProviders, NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './auth/login/login.component';
import {AuthGuard} from './services/auth-guard.service';
import {MainLayoutComponent} from './main-layout/main-layout/main-layout.component';
import { DashboardComponent } from './homepage/dashboard/dashboard.component';
import { ResourcesComponent } from './resources/resources.component';


export const routes: Routes = [
  {
    path: 'main',
    component: MainLayoutComponent,
    data: {pageTitle: 'Home'},
    canActivate: [AuthGuard],
    children: [
      {
        path: 'product',
        loadChildren: './product-list/product-list.module#ProductListModule',
        data: {
          breadcrumb: 'Product'
        }
      },
      {
        path: 'reports',
        loadChildren: './reports/reports.module#ReportsModule',
        data: {
          breadcrumb: 'Reports'
        }
      },
       {
        path: 'admin',
        loadChildren: './admin-panel/admin-panel.module#AdminPanelModule',
        data: {
          breadcrumb: 'Admin'
        },
      },
      {
        path: 'cart',
        loadChildren: './cart-detail/cart-detail.module#CartDetailModule',
        data: {
          breadcrumb: 'Cart'
        }
      },
      // {
      //   path: 'reports',
      //   loadChildren: './reports/reports.module#ReportsModule',
      //   data: {
      //     breadcrumb: 'Reports'
      //   },
      
      // },
      {
        path: 'resources',
       component: ResourcesComponent
      },
      {
        path: 'dashboard',
       component: DashboardComponent
      },
      {
        path: 'home',
        loadChildren: './homepage/homepage.module#HomepageModule',
        data: {
          breadcrumb: 'Homepage'
        }
      },
    
     // {path: '', redirectTo: 'auth/login', pathMatch: 'full' },
    ]
  },
  
  {
    path: '',
    redirectTo:'login',
    pathMatch: 'full',
  },
  {
    path: 'login', component: LoginComponent,

  },

 
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


